import { gql } from "@apollo/client";

export const getCompaniesByBusinessIds = gql`
  query GetCompaniesByBusinessIds($businessIds: [String!]) {
    businessEntity(where: { businessId: { _in: $businessIds } }) {
      id
      businessId
      companies {
        id
        officialName
        businessName
        datahubType
        companyJoinRequests {
          status
        }
      }
    }
  }
`;

export interface BusinessEntity {
  id: string;
  businessId: string;
  companies: Company[];
}

export interface CompanyByBusinessIdResult {
  businessEntity: BusinessEntity[];
}

export interface Company {
  id: string;
  officialName: string;
  businessName: string;
  datahubType: string;
  companyJoinRequests: {
    status: string;
  }[];
}
